var _path, _path2, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCrown1 = function SvgCrown1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 23 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.867 8.2c-3.434-.6-1.8 3.767-5.467 3.3-1.4-.133-2.533-1.2-2.467-2.433.034-1 .9-1.8 2.067-2-1.1-.867-3.5-3.1-4.467-7.067-1.066 3.967-3.366 6.2-4.466 7.033 1.166.2 2.033 1.034 2.066 2 .034 1.234-1.066 2.3-2.466 2.434-3.767.466-1.934-3.9-5.434-3.3-.4.1-.833.166-1.233.266 2.2 2.6 4.133 5.334 5.8 8.167 3.8-.5 7.667-.5 11.467 0A63.721 63.721 0 0 1 23 8.4c-.367-.033-.767-.133-1.133-.2ZM11.5 14.567c-.833 0-1.533-.6-1.567-1.4-.033-.767.667-1.434 1.567-1.434.9 0 1.6.667 1.567 1.434-.034.766-.734 1.4-1.567 1.4Zm0-4.167c-.5-1-1.033-2.033-1.6-3a67.455 67.455 0 0 1 1.6-3.067c.567 1 1.1 2.034 1.6 3.067-.567 1-1.1 2-1.6 3Z",
    fill: "url(#crown1_svg__a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.566 18.233a43.51 43.51 0 0 0-12.133 0 .447.447 0 0 1-.5-.366c-.033-.267.133-.5.4-.534 4.1-.6 8.3-.6 12.4 0 .267.034.433.267.4.534-.067.233-.3.4-.567.366Z",
    fill: "url(#crown1_svg__b)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "crown1_svg__a",
    x1: 11.502,
    y1: 3.329,
    x2: 11.502,
    y2: 15.89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEC467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.228,
    stopColor: "#FFFFCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414,
    stopColor: "#FFDE7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.586,
    stopColor: "#CEA346"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0943B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "crown1_svg__b",
    x1: 11.502,
    y1: 3.329,
    x2: 11.502,
    y2: 15.89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEC467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.228,
    stopColor: "#FFFFCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414,
    stopColor: "#FFDE7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.586,
    stopColor: "#CEA346"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C3A00"
  })))));
};

export default SvgCrown1;